<template>
  <div class="question">
    <label>{{ question.label }}</label>
    <span class="petitBouton" @click="yes"><img src="/assets/icons/check.png" />Oui</span>
    <span class="petitBouton" @click="no"><img src="/assets/icons/cross2.png" />Non</span>
    <span class="petitBouton" @click="next"><img src="/assets/icons/double_right.png" />Passer</span>
  </div>
</template>

<script>
// import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";

export default {
  name: "QuizzQuestion",
  props: ["question"],
  data() {
    return {};
  },
  methods: {
    yes() {
      this.$emit("yes");
    },

    no() {
      this.$emit("no");
    },

    next() {
      this.$emit("next");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

.question {
  font-size: 16px;
  border: $light_border;
  padding: 10px;
  margin-top: 10px;
  display: grid;
  grid-template-columns: 1fr min-content min-content min-content;
  grid-gap: 10px;
  align-items: center;
}
</style>
